export interface SurveyItem {
  itemKey: string;
  label: string;
}

export const SURVEY_GENERAL_ITEMS: SurveyItem[] = [
  {itemKey: "hygiene", label: "Higijena"},
  {itemKey: "working_hours", label: "Radno vreme"},
  {itemKey: "equipment", label: "Opremljenost studija"},
];

/**
 * Lista trenera koji se ocenjuju. Izmeni ovde kad se ekipa promeni - stare
 * ocene ostaju netaknute jer se naziv čuva uz svaku ocenu u bazi.
 */
export const SURVEY_TRAINERS: SurveyItem[] = [
  {itemKey: "trainer:andjela", label: "Anđela"},
  {itemKey: "trainer:maja", label: "Maja"},
  {itemKey: "trainer:latinka", label: "Latinka"},
  {itemKey: "trainer:lana", label: "Lana"},
  {itemKey: "trainer:petra", label: "Petra"},
  {itemKey: "trainer:sara", label: "Sara"},
  {itemKey: "trainer:nadja", label: "Nađa"},
];
